import { CALL_API, Schemas } from '../../../common/middleware/api';
import globalize from '../../../common/services/globalize';

export const MONTHLY_PAYMENT_REPORT_REQUEST = 'MONTHLY_PAYMENT_REPORT_REQUEST';
export const MONTHLY_PAYMENT_REPORT_SUCCESS = 'MONTHLY_PAYMENT_REPORT_SUCCESS';
export const MONTHLY_PAYMENT_REPORT_FAILURE = 'MONTHLY_PAYMENT_REPORT_FAILURE';

export const MONTHLY_PAYMENT_EXPORT_REQUEST = 'MONTHLY_PAYMENT_EXPORT_REQUEST';
export const MONTHLY_PAYMENT_EXPORT_SUCCESS = 'MONTHLY_PAYMENT_EXPORT_SUCCESS';
export const MONTHLY_PAYMENT_EXPORT_FAILURE = 'MONTHLY_PAYMENT_EXPORT_FAILURE';

export const loadMonthlyPaymentReport = (options) => ({
	[CALL_API]: {
		types: [MONTHLY_PAYMENT_REPORT_REQUEST, MONTHLY_PAYMENT_REPORT_SUCCESS, MONTHLY_PAYMENT_REPORT_FAILURE],
		endpoint: `api/reports/payment/monthly`,
		request: options,
		schema: Schemas.MONTHLY_PAYMENT_REPORT_ARRAY
	}
});

export const exportMonthlyPayments = (options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [MONTHLY_PAYMENT_EXPORT_REQUEST, MONTHLY_PAYMENT_EXPORT_SUCCESS, MONTHLY_PAYMENT_EXPORT_FAILURE],
			endpoint: `api/reports/payment/monthly/export`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: 'Excel',
		filename: () => `MonthlyPayments-${options.month}-${options.year}.xlsx`
	});
}